import { FieldType } from '@getaccept/lib-shared-new/src/fields/types/enums/field-type';
import { FieldSource } from '@getaccept/lib-shared-new/src/fields/types/enums/field-source';
import { FieldHelper } from '@getaccept/lib-shared-new/src/fields/helpers/field.helper';
import { Placement } from '@getaccept/fried-tofu';
import { initialHelper } from '@getaccept/lib-shared-new/src/helpers';
import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
import { computed, defineComponent } from 'vue';
import ViewLinkField from './ViewLinkField.vue';
import ViewSignatureField from './ViewSignatureField.vue';
import ViewCheckboxField from './ViewCheckboxField.vue';
export default defineComponent({
    components: {
        ViewCheckboxField,
        ViewSignatureField,
        ViewLinkField,
    },
    props: {
        field: {
            type: Object,
            default: () => ({}),
        },
        recipients: {
            type: Array,
            default: () => [],
        },
        sender: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const fontSize = computed(() => `${(props.field.position.height * 0.6).toFixed(1)}px`);
        const top = computed(() => `${props.field.position.top}px`);
        const left = computed(() => `${props.field.position.left}px`);
        const width = computed(() => `${props.field.position.width}px`);
        const height = computed(() => {
            const dynamicHeight = [FieldType.Text, FieldType.Merge].includes(props.field.type);
            const hasValue = !!props.field.value || !!props.field.label;
            if (dynamicHeight && hasValue) {
                return 'auto';
            }
            return `${props.field.position.height}px`;
        });
        const value = computed(() => {
            if (props.field.type === FieldType.Initials) {
                return initialHelper(fullName.value);
            }
            else {
                return props.field.value || props.field.label || props.field.displayProperty;
            }
        });
        const fullName = computed(() => {
            var _a, _b;
            switch (props.field.source) {
                case FieldSource.Recipient:
                    return (_a = fieldRecipient.value) === null || _a === void 0 ? void 0 : _a.fullName;
                case FieldSource.Sender:
                    return (_b = props.sender) === null || _b === void 0 ? void 0 : _b.fullName;
                default:
                    return null;
            }
        });
        const fieldRecipient = computed(() => {
            var _a;
            if ((_a = props.field) === null || _a === void 0 ? void 0 : _a.recipientId) {
                return props.recipients.find((recipient) => recipient.id === props.field.recipientId);
            }
            return null;
        });
        const completed = computed(() => FieldHelper.fieldCompleted(props.field));
        const fieldType = computed(() => `${props.field.type}-field`);
        const fieldSource = computed(() => {
            switch (props.field.source) {
                case FieldSource.Sender:
                    return 'sender-field';
                case FieldSource.Recipient:
                    return 'recipient-field';
                default:
                    return '';
            }
        });
        const tooltip = computed(() => {
            if (showTooltip.value) {
                return {
                    content: tooltipContent.value,
                    offset: 10,
                    placement: Placement.Top,
                };
            }
            return null;
        });
        const showTooltip = computed(() => [FieldSource.Recipient, FieldSource.Sender].includes(props.field.source));
        const tooltipContent = computed(() => {
            if (props.field.source === FieldSource.Sender) {
                return t('field-assigned-to-you');
            }
            return `${t('field-assigned-to')} ${fullName.value}`;
        });
        return {
            FieldType,
            fieldType,
            fieldSource,
            tooltip,
            fontSize,
            top,
            left,
            width,
            height,
            value,
            completed,
            fullName,
        };
    },
});
